import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-my-referrals',
  imports: [RouterOutlet],
  templateUrl: './my-referrals.component.html',
  styleUrl: './my-referrals.component.scss'
})
export class MyReferralsComponent {}
